import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import StatusErrorIcon from "@atlaskit/icon/core/status-error";

import { wacToken } from "@/libraries/design/foundations";
import { Icon } from "@/libraries/wpl/foundations/src/index";

import { messages } from "./status-message.messages";

const statusContainerStyles = css({
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBlockStart: "14px",
    marginBlockEnd: "16px"
});

const statusIconStyles = css({
    flexShrink: 0,
    borderRadius: "50%",
    color: wacToken("color.neutral.light0"),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "24px",
    width: "24px",
    marginBlockStart: "24px"
});

const successIconStyles = css({
    backgroundColor: wacToken("color.extended.lime700")
});

const statusTextStyles = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "14px",
    color: wacToken("color.primary.black"),
    lineHeight: "1.5"
});

interface StatusMessageProps {
    exceeds: boolean;
}

export const StatusMessage = ({ exceeds }: StatusMessageProps) => {
    const intl = useIntl();

    const statusText = exceeds
        ? intl.formatMessage(messages.exceeds)
        : intl.formatMessage(messages.atPar);

    return (
        <div css={statusContainerStyles}>
            <span
                css={[statusIconStyles, !exceeds && successIconStyles]}
                aria-hidden="true"
            >
                {exceeds ? (
                    <StatusErrorIcon
                        label=""
                        color="var(--ds-icon-danger)"
                        LEGACY_size="large"
                    />
                ) : (
                    <Icon
                        name="featurecheckmark"
                        size="xs"
                        color={wacToken("color.neutral.light0")}
                    />
                )}
            </span>
            <p css={statusTextStyles}>{statusText}</p>
        </div>
    );
};
